import { render, staticRenderFns } from "./DownloadReal.vue?vue&type=template&id=30bdef8a&scoped=true&"
import script from "./DownloadReal.vue?vue&type=script&lang=ts&"
export * from "./DownloadReal.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadReal.vue?vue&type=style&index=0&id=30bdef8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bdef8a",
  null
  
)

export default component.exports